import { apiService } from '../../..'
import { PaymentSourceCaptureMPANFlowRequest, PaymentSourceCaptureResponse } from '@afterpay/types'

const baseUrl = '/portal/consumers'

export const applePayService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    validateMerchant: build.mutation<{ sessionObject: string }, ApplePayJS.ApplePayValidateMerchantEvent>({
      query: (event) => {
        return {
          url: `${baseUrl}/apple-pay-sessions`,
          method: 'POST',
          data: {
            validationUrl: event.validationURL,
          },
        }
      },
    }),
    captureApplePayToken: build.mutation<PaymentSourceCaptureResponse, PaymentSourceCaptureMPANFlowRequest>({
      query: (data) => ({
        url: `${baseUrl}/apple-pay-token/capture`,
        method: 'POST',
        data,
      }),
    }),
  }),
})
